import * as yup from 'yup';
import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { TerritoryClient } from './types';

export const validationSchemaTerritoryFilter = yup.object({
  code: yup
    .string()
    .min(1, 'Il campo territorio deve essere almeno di 1 carattere')
    .max(3, 'Il campo territorio deve essere al massimo di 3 caratteri'),
  state: yup.string(),
});

export const headCells: HeadCell<TerritoryClient, keyof TerritoryClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'exonym',
    label: 'Esonimo',
  },
  {
    id: 'endonym',
    label: 'Endonimo',
  },
  {
    id: 'action',
    label: '',
  },
];

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.TerritorioQuery],
  create: [SystemAuthorizations.TerritorioAdd],
  edit: [SystemAuthorizations.TerritorioUpdate],
  delete: [SystemAuthorizations.TerritorioDelete],
});
